// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3ia3X","actionsCol":"EnrolledClinics_actionsCol__9EwbZ"};